import { jsx as _jsx } from "react/jsx-runtime";
import { useSession } from 'frontend/js/modules/infra/session';
import { useToggle } from 'frontend/js/modules/infra/small-tools/use-toggle';
import { useEngageTable } from './table/use-table';
import { getUrlPrefixFromView, useNavigate } from '../../../../infra/routing';
import { BannerType } from '../../banners';
import { useSetupEngageBanner } from '../../banners/hooks/use-setup-engage-banner';
import { ListViewRedesign } from './list-view-redesign';
export var EngageCampaignListRedesignContainer = function () {
    var _a, _b;
    var _c = useEngageTable(), table = _c.table, isLoading = _c.isLoading, emptyTableState = _c.emptyTableState, onRowClick = _c.onRowClick, pagination = _c.pagination, count = _c.count, filters = _c.filters, sort = _c.sort;
    var session = useSession().data;
    var urlPrefix = getUrlPrefixFromView(session.view);
    var navigate = useNavigate();
    var isFiltersOpen = useToggle();
    useSetupEngageBanner({
        bannerType: BannerType.AutomatedCampaign,
        onPrimaryClick: function () { return navigate("".concat(urlPrefix, "/engagement/automated")); },
    });
    var navigateToCreateCampaign = function () {
        navigate("".concat(urlPrefix, "/engagement/new"));
    };
    var hasActiveFilter = sort.sortName !== 'createdAtDesc' ||
        ((_a = filters.filterState.statusFilter) === null || _a === void 0 ? void 0 : _a.length) ||
        ((_b = filters.filterState.typeFilter) === null || _b === void 0 ? void 0 : _b.length) ||
        filters.filterState.creatorFilter.length;
    return (_jsx(ListViewRedesign, { table: table, isLoading: isLoading, emptyTableState: emptyTableState, onRowClick: onRowClick, count: count, pagination: pagination, onOpenFilters: isFiltersOpen.setOn, isFiltersOpen: isFiltersOpen.isOn, onCloseFilters: isFiltersOpen.setOff, filters: filters, sort: sort, hasActiveFilter: !!hasActiveFilter, onCreateCampaign: navigateToCreateCampaign }));
};
